module.exports = vendor_d8eaa208cf196d2aabb6;


//////////////////
// WEBPACK FOOTER
// external "vendor_d8eaa208cf196d2aabb6"
// module id = 42
// module chunks = 0